module.exports = __webpack_public_path__ + "img/bg_right.a1307d55.png";